export interface WicketNft {
  id: string;
  address: string;
  metadata: {
    name: string;
    description: string;
    image: string;
    image_preview: string;
    atributes: WicketNftAtribute[];
    background_color: string;
  };
}

interface WicketNftAtribute {
  trait_type: 'event_id' | 'event_start_at' | 'event_location' | string;
  value: string;
  display_type: 'string' | 'boolean' | 'datetime' | 'hidden';
}
